export default {
    data() {
        return {
            previousDays: 3,    //查看n天内的消息

            num: 2,             //消息列表页面一次显示n条记录数
            seconds: 5 * 1000,  //消息列表页面停留5秒认为已读消息

            stayIndexSeconds: 5 * 60 * 1000,  //header间隔5min发起一次未读消息查询

            NOTICE_PERMISSION: "menu.notice.oper",  //权限字符串

            BUSSINESSTYPE: 'NOTICE',    //附件保存路径
        }
    },
}